<div class="component-settings-container">
  @if (selectedComponent != null) {
    <button class="component-settings-close-button" mat-icon-button (click)="onClose($event)">
      <mat-icon>close</mat-icon>
    </button>

    <div class="component-settings-form">
      <div>name: {{ selectedComponent.gridComponent.name }}</div>
      <div>id: {{ selectedComponent.gridComponent.id }}</div>
    </div>

    @switch (selectedComponent.gridComponent.name) {
      @case ('pushButton') {
        <app-push-button-form
          (handleName)="componentFieldChange($event)"
          (handleId)="componentFieldChange($event)"
          component
          label="test label"
          id="testId"
          [componentName]="selectedComponent.gridComponent.name"
          [componentId]="selectedComponent.gridComponent.id"
        ></app-push-button-form>
      }

      @default {
        <p>Unknown component type</p>
      }
    }

    <div>component settings</div>
  }
</div>
